import { IBuilder } from '@cian/frontend-newbuilding-call-component/es/types/builder';
import { ISeller } from '@cian/frontend-newbuilding-call-component/es/types/seller';
import { INewbuildingBuilder } from '../../types/developer/builder';
import { INewbuildingSeller } from '../../types/developer/sellers';

const EMPTY_PHONE = {
  code: '',
  countryCode: '',
  number: '',
};

export function mapBuilder(builder: INewbuildingBuilder): IBuilder {
  // oxlint-disable-next-line no-unused-vars
  const { workTimeInfo, dynamicCalltracking, realtyUserId, showPhone, isFichering, phone, ...restBuilder } = builder;

  return {
    ...restBuilder,
    dynamicCalltracking: dynamicCalltracking || {},
    isFichering: Boolean(isFichering),
    phone,
    realtyUserId: realtyUserId ?? 0,
    showPhone: Boolean(showPhone),
  };
}

export function mapSeller(seller: INewbuildingSeller): ISeller {
  // oxlint-disable-next-line no-unused-vars
  const { workTimeInfo, dynamicCalltracking, realtyUserId, showPhone, phone, ...restSeller } = seller;

  return {
    ...restSeller,
    dynamicCalltracking: dynamicCalltracking || {},
    phone: phone || EMPTY_PHONE,
    realtyUserId: realtyUserId ?? 0,
    showPhone: Boolean(showPhone),
  };
}
